module.exports = __webpack_public_path__ + "static/media/Nguyen_Thi_Ngoc_Huyen.07854c1b.jpg";